import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
  selector: 'loyaltic-email-reminder',
  templateUrl: './email-reminder.component.html',
  styleUrls: ['./email-reminder.component.scss']
})
export class EmailReminderComponent implements OnInit {

  email: any;
  emailSubmitted = false;

  constructor(
    private coreService: CoreService,
    private toast: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
  }

  onSubmit(formRef: any) {
    const body = {
      Email: this.email,
    };

    this.coreService.emailReminder(body).then((reminderResponse: any) => {
      formRef.submitted = false;
      localStorage.removeItem('inviterId');
      this.resetForm();
      const successMessage = this.translate.instant(reminderResponse.messageKey);
      this.toast.success(successMessage, 'Success');
      this.emailSubmitted = true;
    }).catch((errorResponse: any) => {
      const errorMessage = this.translate.instant(errorResponse.error.messageKey);
      this.toast.error(errorMessage, 'Error');
      return;
    });
  }

  resetForm() {
    this.email = undefined;
  }

}
